<ion-button
  mode="ios"
  shape="round"
  [disabled]="disabled"
  (click)="buttonClick.emit($event)"
  class="onboarding-button-v2"
>
  <ng-content></ng-content>
</ion-button>
